const socialLinks = [
    {
        icon: 'facebook',
        url: 'https://www.facebook.com/tomas.scattini/'
    },
    {
        icon: 'twitter',
        url: 'https://twitter.com/tomiscattini'
    },
    {
        icon: 'linkedin',
        url: 'https://www.linkedin.com/in/tomas-scattini/'
    },
    {
        icon: 'instagram',
        url: 'https://instagram.com/tomiscattini/'
    }
];

export default socialLinks;
